<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="none" viewBox="0 0 48 48">
  <path fill="#fff" d="M11 10h26v26H11z"/>
  <path stroke="#000" stroke-width="2" d="M11 10h26v26H11z"/>
  <path stroke="#000" stroke-width="2" d="M20 23v13h8V23h-8z" clip-rule="evenodd"/>
  <path stroke="#000" stroke-width="2" d="M7 36h34"/>
</svg>
